export const domainSharingRadioOptions = [
  {
    value: 'canFindInSearchResults',
    displayValue: 'Can find in search results',
  },
  {
    value: 'mustHaveLinkToAccess',
    displayValue: 'Must have link to access',
  },
];

export const userSharingRadioOptions = [
  {
    value: 'fileSharedToUserExternalToDomain',
    displayValue: 'user external to the domain',
  },
  {
    value: 'fileSharedToUserInternalToDomain',
    displayValue: 'user internal to the domain',
  },
  {
    value: 'fileIsSharedPublic',
    displayValue: 'anyone with the link (public)',
  },
  {
    value: 'fileSharedToSpecificUser',
    displayValue: 'specific user',
  },
  {
    value: 'fileIsSharedToDomain',
    displayValue: 'domain',
  },
];
